import { render, staticRenderFns } from "./modal-draft-success.vue?vue&type=template&id=c77ea630&"
import script from "./modal-draft-success.vue?vue&type=script&lang=js&"
export * from "./modal-draft-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports